export default __webpack_public_path__ + "static/media/inlife.24fe03d6.png";